import type { ApiException } from '@stakeholderlabs/shared'
import { useHandleError } from '@stakeholderlabs/shared'
import { useHomepageApi } from '~/composables/api/useHomepageApi'
import { useArticle } from '~/composables/useArticle'

export const useHomepage = async () => {
  const { show } = useHomepageApi()

  const { data, error } = await useAsyncData('homepage', () => show())

  if (error.value || !data.value) {
    throw createError(useHandleError(error.value as ApiException))
  }

  return useArticle(data.value.data)
}
